<template>
	<div class="common">
		<div class="user-comment-inner">
			<div class="user-comment-wrap">
				<div class="ds_fx">
					<div class="user-comment-container">
						<div class="user-comment-desc">
							<span>
								<div class="desc-top">
									<h2>{{ $t('comment.title') }} </h2>
									<b>{{ $t('comment.Subtitle') }}</b>
								</div>
								<div class="desc-text">
									<p>{{ $t('comment.text') }}</p>
								</div>
							</span>
						</div>
						<div class="view-comment-btn">
							<div class="prev-btn btn" @click="onPrev" :class="currentIndex == 0 ? 'clickable' : ''">
								<span class="iconfont icon-zuojiantou"></span>
							</div>
							<div class="next-btn btn" @click="onNext"
								:class="currentIndex == userComment.length -1 ? 'clickable' : ''">
								<span class="iconfont icon-youjiantou"></span>
							</div>
						</div>
					</div>
					<div class="comment-list-wrap" :style="{ height: CommentWrapHeight + 'px' }">
						<div ref="wrapHeight" class="comment-item ml-32" v-for="(commont, index) in userComment"
							:key="commont.id" :style="{
								transform: `translateX(${(index - currentIndex) * 100}%)`,
							    transition: 'opacity 300ms, transform 300ms, visibility 300ms',
								opacity: (index - currentIndex) * 100 < 0 ? 0 : 1,
							    visibility: 'visible'
							  }">
							<span class="comment-item-detail">
								<div class="comment-text">
									{{ $t(`userComment.${index}.content`)}}
								</div>
								<div class="comment-user">
									<div class="from">
										<div class="commont-user-avatr">{{ commont.avatr }}</div>
										<div class="commont-user-name">{{ commont.user }}</div>
									</div>
									<div class="product">{{ commont.purchased_goods }}</div>
								</div>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'userCommon',
		components: {},
		data() {
			return {
				CommentWrapHeight: '',
				currentIndex: 0,
				userComment: [{
						id: 1,
						avatr: 'C',
						content: 'уже вторая покупка такой приставки, работает нормально, подключиося к интернету быстро просто, всё пока устраивает, замечаний нет! ',
						user: 'Сергей Л.',
						purchased_goods: 'Оперативная память: 4 ГБ, Встроенная память, ГБ: 64',
						comment_url: 'https://www.ozon.ru/context/client_opinion/ClientGuid/07988cb7-0762-47fd-82ec-2f2e78abdc6f/?itemId=1776819445&reviewUuid=01972521-beb0-7560-b32a-e077d9539d6b'
					},

					{
						id: 2,
						avatr: 'A',
						content: 'отлично! в коробке всё работает "из коробки"! есть и тв каналы и фильмы! всё работает без тормозов и глюков ',
						user: 'Александр Р.',
						purchased_goods: 'Оперативная память: 4 ГБ, Встроенная память, ГБ: 64',
						comment_url: 'https://www.ozon.ru/context/client_opinion/ClientGuid/07988cb7-0762-47fd-82ec-2f2e78abdc6f/?itemId=1776819445&reviewUuid=01972521-beb0-7560-b32a-e077d9539d6b'
					},
					{
						id: 3,
						avatr: 'A',
						content: 'Отличное качество, все работает без проблем Очень нравится, приложения устанавливаются без проблем ',
						user: 'Артур И.',
						purchased_goods: 'Оперативная память: 4 ГБ, Встроенная память, ГБ: 64',
						comment_url: 'https://www.ozon.ru/context/client_opinion/ClientGuid/07988cb7-0762-47fd-82ec-2f2e78abdc6f/?itemId=1776819445&reviewUuid=01972521-beb0-7560-b32a-e077d9539d6b'
					},
					{
						id: 5,
						avatr: 'Е',
						content: 'отличная приставка,гораздо лучше которой пользовался раньше,качественная картинка,шустро работает.В настройке без проблем. ',
						user: 'Евгений К.',
						purchased_goods: 'Оперативная память: 4 ГБ, Встроенная память, ГБ: 64',
						comment_url: 'https://www.ozon.ru/context/client_opinion/ClientGuid/07988cb7-0762-47fd-82ec-2f2e78abdc6f/?itemId=1776819445&reviewUuid=01972521-beb0-7560-b32a-e077d9539d6b'
					},
					{
						id: 4,
						avatr: 'В',
						content: 'Покупкой доволен, клиенты тоже. Кому что нужно, то и устанавливаю, имею ввиду прошивки. Общем люди довольны и я не в накладе. ',
						user: 'Виктор Ш.',
						purchased_goods: 'Цвет товара: черный ',
						comment_url: 'https://www.ozon.ru/context/client_opinion/ClientGuid/07988cb7-0762-47fd-82ec-2f2e78abdc6f/?itemId=1776819445&reviewUuid=01972521-beb0-7560-b32a-e077d9539d6b'
					},
					{
						id: 6,
						avatr: 'D',
						content: 'Я знал, что покупаю - это на сегодня самый лучший по соотношению цена/качество ТВ-бокс!К приобретению могу смело советовать! ',
						user: 'DEMYAN S.',
						purchased_goods: 'Оперативная память: 4 ГБ, Встроенная память, ГБ: 64',
						comment_url: 'https://www.ozon.ru/context/client_opinion/ClientGuid/07988cb7-0762-47fd-82ec-2f2e78abdc6f/?itemId=1776819445&reviewUuid=01972521-beb0-7560-b32a-e077d9539d6b'
					}
				]
			};
		},
		computed: {},
		methods: {
			calculateMaxHeight() {
				let max = 0
				this.$el.querySelectorAll('.comment-item-detail').forEach(el => {
					max = Math.max(max, el.offsetHeight)
				})
				this.CommentWrapHeight = max
			},
			onPrev() {
				if (this.currentIndex > 0) {
					this.currentIndex--
				} else {
					// 如果到达开头，只能下一张
					this.currentIndex = 0
				}
			},
			onNext() {
				if (this.currentIndex < this.userComment.length - 1) {
					this.currentIndex++
				} else {
					// 如果到达末尾，循环回到上一张
					this.currentIndex = this.userComment.length - 1
				}
			}
		},
		created() {

		},
		mounted() {
		// 获取最高的元素的高度
			this.calculateMaxHeight()
		},
		updated() {},
	}
</script>
<style lang='less' scoped>

</style>